<template>
    <v-fab variant="tonal" rounded size="large" app :text="text" :prepend-icon="icon" :color="color"></v-fab>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: false,
            default: 'mdi-plus'
        },
        color: {
            type: String,
            required: false,
            default: '#00773D'
        }
    }
}
</script>